import React, { forwardRef, useState } from 'react';
import {
  GestureResponderEvent,
  StyleSheet,
  Text,
  TextProps,
} from 'react-native';
import {
  PressableAnalyticsProps,
  usePressableAnalytics,
} from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

type HyperlinkSmTextProps = PressableAnalyticsProps & TextProps;

const HyperlinkXsText = forwardRef<Text, HyperlinkSmTextProps>(
  ({ children, style, analyticsId, customAttributes, ...props }, ref) => {
    const [isPressed, setIsPressed] = useState(false);

    const linkAnalytics = usePressableAnalytics({
      analyticsId,
      customAttributes,
    });

    const handlePress = (event: GestureResponderEvent) => {
      setIsPressed(true);
      linkAnalytics?.();
      if (props?.onPress) {
        props.onPress(event);
      }

      setTimeout(() => {
        setIsPressed(false);
      }, 100);
    };

    return (
      <Text
        ref={ref}
        style={[styles.hyperlinkXsText, style]}
        testID={props.testID}
        accessible
        accessibilityRole={props.accessibilityRole || 'link'}
        accessibilityLabel={props.accessibilityLabel}
        {...props}
        onPress={props.onPress ? handlePress : undefined}
        disabled={isPressed}
      >
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  hyperlinkXsText: {
    ...theme.typography.hyperlink.xs,
  },
});

export default HyperlinkXsText;
